module.exports = __webpack_public_path__ + "img/icon-try-on.light.186adcb0.svg";